module.exports = __webpack_public_path__ + "img/facility.0ad76ea7.svg";